import { Box } from "@mui/system";
import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { MICROSITE_CONNECT_ACCOUNT_SUCCESS, MICROSITE_CONNECT_MORE_ACCOUNTS, trackEvent } from "../../analytics";
import { AttentionBox, Background, DropdownMessage, FullScreenLoader, InvertedPrimaryButton, NavBar, PrimaryButton } from "../../Components";
import Icons from "../../Components/Icons/icons";
import { ROUTE_LANDING_PAGE } from "../../Routes/RouteMapping";
import { getAccountDetails, getAccountInfo, getConnectedAccountDetails, getWorkplatformDetails } from "../../utils/api";
import { CONNECTED_ACCOUNT_ID, CONNECTED_STORAGE_WORK_PLATFORM_ID, CONNECTED_USER_ID, INSTAGRAM_WORK_PLATFORM_NAME, STORAGE_AUTH_DATA, STORAGE_AUTH_TENANT_APP_NAME, STORAGE_WORK_PLATFORM_NAME, SUCCESS_PAGE_CONTENT } from "../../utils/constants";
import "./SuccessPage.scss";
import parse from "html-react-parser";

function SuccessPage() {
  const navigate = useNavigate();
  const [appName, setAppName] = useState();
  const onlyOnce = useRef(true);
  const [isLoading, setIsLoading] = useState(true);
  const [accountDetails, setAccountDetails] = useState([]);
  const [workPlatformName, setWorkPlatformName] = useState("")

  useEffect(() => {
    (async () => {
      if (sessionStorage.getItem(STORAGE_AUTH_DATA)) {
        const auth = JSON.parse(sessionStorage.getItem(STORAGE_AUTH_DATA));
        if (onlyOnce.current) {
          onlyOnce.current = false;
          const connectedAccountIDs = JSON.parse(sessionStorage.getItem(CONNECTED_ACCOUNT_ID));
          const workPlatformName = sessionStorage.getItem(STORAGE_WORK_PLATFORM_NAME);
          setWorkPlatformName(workPlatformName)
          setIsLoading(true)
          const accountPromises = connectedAccountIDs.map(async (accountId) => {
            const response = await getAccountInfo(accountId);
            return response;
          });

          let allAccountInfo = await Promise.all(accountPromises);
          setAccountDetails(allAccountInfo)
          setIsLoading(false)

          trackEvent(MICROSITE_CONNECT_ACCOUNT_SUCCESS, { creator_user_id: allAccountInfo[0]?.user?.id, work_platform_name: workPlatformName });
        }
        setAppName(auth[STORAGE_AUTH_TENANT_APP_NAME]);
      }
    })();
  }, []);

  if (!appName || isLoading) return <FullScreenLoader showLoader={isLoading} />;

  return (
    <>
      <Background>
        <Box className="success-page-body">
          <Box className="success-page-header" >
            <label> {SUCCESS_PAGE_CONTENT.header} {appName} </label>
            <Box className="circular-icon" > {SUCCESS_PAGE_CONTENT.icon}</Box>
          </Box>

          <Box className="profile_main_div" >
            {accountDetails &&
              accountDetails.length > 0 &&
              accountDetails.map((accountDetails, index) => (
                <div
                  className="profile-box"
                  key={accountDetails.id}
                >
                  <div className="profile-pic">
                    {accountDetails.profile_pic_url ?
                      <img

                        src={
                          accountDetails?.profile_pic_url
                        }
                        alt=""
                        onError={(e) => {
                          // e.target.src = placeholder_profilepic;
                        }}
                      /> :
                      <Icons.placeholder_profile />}
                  </div>
                  <div className="profile-info">
                    <p className="text-truncate profile-username">{accountDetails.platform_username}</p>
                    <div className="status-icon">
                      {accountDetails.status === "CONNECTED" ? (
                        <div>
                          <Icons.completed_icon /><label> Connected</label>
                        </div>
                      ) : null}
                    </div>
                  </div>
                  <div className="platform-logo">
                    <img src={accountDetails.work_platform?.logo_url} />
                  </div>
                </div>
              ))}
          </Box>
          {workPlatformName && workPlatformName === INSTAGRAM_WORK_PLATFORM_NAME && <Box className="attention-box-container">
            <AttentionBox content={SUCCESS_PAGE_CONTENT.instaAttentionMsg} />
          </Box>}
          {appName && <Box className="contact-info" sx={workPlatformName !== INSTAGRAM_WORK_PLATFORM_NAME && { marginTop: "64px !important" }}>
            {SUCCESS_PAGE_CONTENT?.contactInfo?.map((data, index) => (
              <p key={index}> {parse(data.replace("appName", appName))} </p>
            ))}
          </Box>}
          <Box className="button-group">
            <PrimaryButton
              onClick={() => {
                window.close();
              }}
              htmlType="submit"
              label="Done"
            />
            <InvertedPrimaryButton
              onClick={() => navigate(ROUTE_LANDING_PAGE)}
              label={<> <Icons.add_other_platforms /> Connect another account</>}
            />
          </Box>
        </Box>
      </Background>
    </>
  );
}

export default SuccessPage;
